import api from "../../services/api";
import {
  ADD_CHAPTER_COMMENT_FAILURE,
  ADD_CHAPTER_COMMENT_REQUEST,
  ADD_CHAPTER_COMMENT_SUCCESS,
  ADD_COMMENT_REPLY_FAILURE,
  ADD_COMMENT_REPLY_REQUEST,
  ADD_COMMENT_REPLY_SUCCESS,
  GET_CHAPTER_COMMENTS_FAILURE,
  GET_CHAPTER_COMMENTS_REQUEST,
  GET_CHAPTER_COMMENTS_SUCCESS,
  RESET_ALL_COMMENT_STATE,
} from "./ActionType";

const addChapterCommentRequest = () => ({
  type: ADD_CHAPTER_COMMENT_REQUEST,
});

const addChapterCommentSuccess = (comment) => ({
  type: ADD_CHAPTER_COMMENT_SUCCESS,
  payload: comment,
});

const addChapterCommentFailure = (error) => ({
  type: ADD_CHAPTER_COMMENT_FAILURE,
  payload: error,
});

export const addChapterComment = (chapterId, commentData) => {
  return async (dispatch) => {
    dispatch(addChapterCommentRequest());
    try {
      const response = await api.post(
        `/chapters/${chapterId}/comments`,
        commentData
      );
      const data = response.data;
      dispatch(addChapterCommentSuccess(data));
    } catch (error) {
      dispatch(addChapterCommentFailure(error.message));
    }
  };
};

const getChapterCommentsRequest = () => ({
  type: GET_CHAPTER_COMMENTS_REQUEST,
});

const getChapterCommentsSuccess = (comments) => ({
  type: GET_CHAPTER_COMMENTS_SUCCESS,
  payload: comments,
});

const getChapterCommentsFailure = (error) => ({
  type: GET_CHAPTER_COMMENTS_FAILURE,
  payload: error,
});

export const getChapterComments = (chapterId) => {
  return async (dispatch) => {
    dispatch(getChapterCommentsRequest());
    try {
      const response = await api.get(`/chapters/${chapterId}/comments`);
      const data = response.data;
      dispatch(getChapterCommentsSuccess(data));
    } catch (error) {
      dispatch(getChapterCommentsFailure(error.message));
    }
  };
};

const addCommentReplyRequest = () => {
  return {
    type: ADD_COMMENT_REPLY_REQUEST,
  };
};

const addCommentReplySuccess = (reply) => {
  return {
    type: ADD_COMMENT_REPLY_SUCCESS,
    payload: reply,
  };
};

const addCommentReplyFailure = (error) => {
  return {
    type: ADD_COMMENT_REPLY_FAILURE,
    payload: error,
  };
};

export const addCommentReply = (commentId, replyData) => {
  return async (dispatch) => {
    dispatch(addCommentReplyRequest());
    try {
      const response = await api.post(
        `/comments/${commentId}/replies`,
        replyData
      );
      const data = response.data;
      dispatch(addCommentReplySuccess(data));
    } catch (error) {
      dispatch(addCommentReplyFailure(error.message));
    }
  };
};

export const resetAllCommentState = () => {
  return {
    type: RESET_ALL_COMMENT_STATE,
  };
};
